var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"example"},[_vm._v("\n    "+_vm._s(_vm.configuration.component_data)+"\n    "),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }